import React, { useState, useEffect } from 'react';
import { APIROOT } from '../../Helpers/configs';

import { expiryDate, convertDate, filterMethod } from '../../Helpers/helpers';

// import { filterMethod } from '../../../Helpers/helpers';

import {
  Grid,
  Typography,
  TextField,
  Autocomplete,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@mui/material';

import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

import { ticketTypoTitle, ticketTypoInfo } from '../shared/commonStyle';

const CabinetDisplayInfo = (props) => {
  const cabId = props.cabinetId;
  const [history, setHistory] = useState([]);
  const [cabinetData, setCabinetData] = useState(props.cabinetData);

  const [cabinetType, setCabinetType] = useState([
    {
      id: cabinetData.cabId,
      name: cabinetData.cabType,
    },
  ]);
  const [serialNumber, setSerialNumber] = useState({
    id: cabinetData.serialId,
    name: cabinetData.serialNo,
    install_date: cabinetData.install_date,
  });
  const [expiryDateVal, setExpiryDateVal] = useState('');

  const [exp, setExp] = useState('');
  const handleExpChange = (event) => {
    setExp(event.target.value);
  };

  useEffect(() => {
    const serial = serialNumber;
    const data = fetchHistory(serial.id, setHistory);
    data === undefined ? setHistory([]) : setHistory(data);
  }, [serialNumber]);

  const calculateWarrantee = (list) => {
    const dateGroup = list[0];

    const dateGroupObj = dateGroup;

    let data =
      dateGroupObj === undefined
        ? 'No Date Set'
        : expiryDate(dateGroup.install_date, dateGroup.warranty_period);

    setExpiryDateVal(data);
  };

  const [ticketDataReq, setTicketDataReq] = useState([]);

  useEffect(() => {
    cabinetBySerial(cabinetData.id).then((data) => {
      setTicketDataReq(data.data.value);
      calculateWarrantee(data.data.value);
    });
  }, [cabinetData]);

  return (
    <Grid
      container
      xs={12}
      md={12}
      flexDirection='row'
      rowGap={1}
      // columnGap={1}
      alignContent='flex-start'
    >
      <Grid
        container
        xs={12}
        md={12}
        flexDirection='row'
        rowGap={1}
        // columnGap={1}
        alignContent='flex-start'
      >
        <Grid item xs={12} md={1.2}>
          <Typography style={ticketTypoTitle}>Cabinet Type:</Typography>
        </Grid>
        <Grid item xs={12} md={2.5}>
          <Typography
            sx={{
              width: '100%',
            }}
            name='cabinetType'
            key='cabinetType'
            id='cabinetType'
            variant='standard'
            size='small'
          >
            {cabinetData.cabType}
          </Typography>
        </Grid>
        <Grid item xs={12} md={1.2}>
          <Typography style={ticketTypoTitle}>Serial Number:</Typography>
        </Grid>
        <Grid item xs={12} md={2.5}>
          <Typography
            sx={{
              width: '100%',
              padding: 0,
            }}
            name='serialNumber'
            key='serialNumber'
            id='serialNumber'
            variant='standard'
            size='small'
          >
            {cabinetData.serialNo}
          </Typography>
        </Grid>
        <Grid item xs={12} md={1.3}>
          <Typography style={ticketTypoTitle}>Warrantee Expiry:</Typography>
        </Grid>
        <Grid item xs={12} md={2.0}>
          <Typography
            // value={expiryDateVal}
            id='expDate'
            // onChange={handleExpChange}
            style={ticketTypoInfo}
          >
            {expiryDateVal}
          </Typography>
        </Grid>
        <Grid item xs={12} md={0.5}></Grid>

        <Grid item xs={12} md={1.2}>
          <Typography style={ticketTypoTitle}>History:</Typography>
        </Grid>

        <Grid item xs={12} md={10.3}>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              background='#ffffff'
              aria-controls='panel1a-content'
              id='panel1a-header'
            >
              <Typography>Repair History</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer>
                <Table
                  sx={{ minWidth: 650 }}
                  size='small'
                  aria-label='a dense table'
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Repair Details</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {history.map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          '&:last-child td, &:last-child th': {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell component='th' scope='row'>
                          {convertDate(row.ticket_date, 0, 10)}
                        </TableCell>
                        <TableCell>{row.description}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CabinetDisplayInfo;

function fetchHistory(serialID, setDataFunc) {
  //Get JWT from storage
  let JWT = localStorage.getItem('JWT_Key');

  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  const request = new Request(
    `${APIROOT}/api/serialnumberhistory/${serialID}`,
    { method: 'POST', headers: headers }
  );

  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);
      if (parsed.success === true) {
        setDataFunc(parsed.data.value);
        if (parsed.JWT) {
          localStorage.setItem('JWT_Key', parsed.JWT);
        }
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

//TICKET DATA
async function cabinetBySerial(Serial) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {
    pagereq: {
      filter: {
        fullfilter: [
          {
            field: 'serial_number',
            search: 'RDAT201180-0052-196',
            strict: true,
          },
        ],
      },
    },
  };

  const request = new Request(`${APIROOT}/api/serialnumbers/`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}
